import { createContext } from "react";
import type { Account } from "../lib/account";
import type { Rating } from "../lib/types";

export type AuthMode = "signin" | "create";

export interface RegisterInput {
  username: string;
  password: string;
  email?: string;
}

export interface AuthValue {
  account: Account | null;
  ratings: Rating[] | null;
  register(input: RegisterInput): Promise<void>;
  signIn(input: { username: string; password: string }): Promise<void>;
  signOut(): Promise<void>;
  refreshMe(): Promise<Rating[] | null>;
  openAuth(mode?: AuthMode): void;
  closeAuth(): void;
}

// Split into its own module so AuthProvider / useAuth / AuthModal share the
// context without an import cycle.
export const AuthContext = createContext<AuthValue | null>(null);
